class ProductGridSwitcher extends HTMLElement {
  constructor() {
    super();

    this.onButtonClick = this.onButtonClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
    
    // edit by sb
    this.currentLayout = '2';
    // endcomment 
    this.layoutClasses = {
      '1': 'grid--1-col-desktop',
      '2': 'grid--2-col-desktop',
      '2-multi': 'grid--2-col-desktop multi-col'
    };
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('.collection-view-btn');
    if (!this.buttons.length) return;

    this.buttons.forEach((btn) => {
      btn.addEventListener('click', this.onButtonClick);
    });

    this.applyLayout();

    const activeBtn = this.querySelector(
      `.collection-view-btn[data-layout="${this.currentLayout}"]`
    );

    if (activeBtn) {
      this.updateButtons(activeBtn);
    }

    document.addEventListener('product-grid:updated', this.handleGridUpdate);

    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    this.buttons.forEach((btn) => {
      btn.removeEventListener('click', this.onButtonClick);
    });

    document.removeEventListener('product-grid:updated', this.handleGridUpdate);
    window.removeEventListener('resize', this.handleResize);
  }

  handleGridUpdate = () => {
    this.applyLayout();
  };

  handleResize() {
    this.applyLayout();
  }

  onButtonClick(event) {
    // Mobile/tablet only
    if (window.innerWidth > 749) return;

    const btn = event.currentTarget;
    const layout = btn.dataset.layout;

    // Store current layout in memory only
    this.currentLayout = layout;

    console.log('Selected layout:', layout);

    this.applyLayout();
    this.updateButtons(btn);
  }

  applyLayout() {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    // Remove previous classes
    [
      'grid--1-col-desktop',
      'grid--2-col-desktop',
      'grid--5-col-desktop',
      'multi-col'
    ].forEach((className) => {
      grid.classList.remove(className);
    });

    // Desktop: don't apply mobile layout
    if (window.innerWidth > 749) return;

    const activeClass = this.layoutClasses[this.currentLayout];

    if (activeClass) {
      activeClass.split(' ').forEach((className) => {
        grid.classList.add(className);
      });
    }
  }

  updateButtons(activeBtn) {
    this.buttons.forEach((btn) => {
      const isActive = btn === activeBtn;

      btn.classList.toggle('is-active', isActive);
      btn.setAttribute(
        'aria-pressed',
        isActive ? 'true' : 'false'
      );
    });
  }
}

customElements.define('product-grid-switcher', ProductGridSwitcher);